import IconArrowDownFilled from '@picsart/icons/IconArrowDownFilled';
import IconMessage from '@picsart/icons/IconMessage';
import IconLogout from '@picsart/icons/IconLogout';
import Link from '@picsart/link/Link';
import { Typography, FontWeights } from '@picsart/cascade';
import Text from '@picsart/text/Text';
import Avatar from '@picsart/avatar/Avatar';
import cls from 'classnames';
import { memo, useCallback } from 'react';

import { DropdownOpenDirection } from '../Login/LoginArea/types';
import PicsartLogo from '../../../data/nav/PicsartLogo';
import { Analytics } from '../../../services/analytics';

import { useLogout, useMenuReposition, useMenuVisibility, useGetOwnProfile } from './hooks';
import { useProfileStore } from './profileStore';
import useStyles from './styles';

const SETTINGS_URL = 'https://picsart.com/settings';
const HELP_URL = 'https://support.picsart.com/hc/en-us';

type ProfileProps = {
  dropdownOpenDirection: DropdownOpenDirection;
  showName?: boolean;
  analytics: Analytics;
};

function Profile({ dropdownOpenDirection, showName, analytics }: ProfileProps) {
  const classes = useStyles();
  const { showMenu, hideMenu, toggleMenu, menuVisible } = useMenuVisibility();
  const avatarUrl = useProfileStore((state) => state.photo);
  const name = useProfileStore((state) => state.name || state.username || state.email);
  const { menu, left, top } = useMenuReposition(menuVisible, dropdownOpenDirection);
  const logout = useLogout();
  const trackOpenPicsart = useCallback(() => {
    analytics.pageClick({
      page_path: window.location.pathname,
      action_type: 'open_picsart',
    });
  }, []);

  useGetOwnProfile();

  return (
    <div
      className={classes.root}
      onMouseEnter={showMenu}
      onMouseLeave={hideMenu}
      onTouchStart={toggleMenu}
    >
      <div className={classes.avatar}>
        <Avatar size={40} imageAlt="avatar" imageSrc={avatarUrl} />
        {showName && (
          <Text weight={FontWeights.SemiBold} size={Typography.t5} className={classes.name}>
            {name}
          </Text>
        )}
        <div className={cls(classes.arrowContainer, showName && classes.grow)}>
          <IconArrowDownFilled className={classes.avatarIcon} />
        </div>
      </div>
      <ul
        ref={menu}
        style={{ top, left, display: menuVisible ? 'flex' : 'none' }}
        className={classes.menu}
        onTouchStart={(e) => e.stopPropagation()}
      >
        <Link
          href={SETTINGS_URL}
          target="_blank"
          className={classes.text}
          weight={FontWeights.SemiBold}
          size={Typography.t5}
          onClick={trackOpenPicsart}
        >
          <li className={classes.row}>
            <PicsartLogo />
            Open Picsart
          </li>
        </Link>
        <Link
          className={classes.text}
          weight={FontWeights.SemiBold}
          size={Typography.t5}
          target="_blank"
          href={HELP_URL}
        >
          <li className={classes.row}>
            <IconMessage className={classes.icon} />
            Help
          </li>
        </Link>
        <Link className={classes.text} weight={FontWeights.SemiBold} onClick={logout as any}>
          <li className={classes.row}>
            <IconLogout className={classes.icon} />
            Logout
          </li>
        </Link>
      </ul>
    </div>
  );
}

export default memo(Profile);
